import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ActionsPanel from '../../../components/Editor/ActionsPanel';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: { spreadZoom, activeItem },
	} = state;

	return {
		spreadZoom,
		id: activeItem.id,
	};
};

export default connect(mapStateToProps)(ActionsPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ActionsPanel/index.tsx